module.exports = __webpack_public_path__ + "img/title.6dd739c3.png";